import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '@/components/common/Header';

export function DashboardLayout() {

  return (
    <div className="min-h-screen bg-primary/10 flex">
      <Header />
      <main className="flex-1 mt-[65px]">
        <Outlet />
      </main>
    </div>
  );
}
